export const SEARCHPATHS = [
    {name: "Manhattan Sales", link: "/Sales/manhattan"},
    {name: "Manhattan Rentals", link: "/Rentals/manhattan"},
    {name: "Hamptons Sales", link: "/Sales/hamptons"},
    {name: "Hamptons Rentals", link: "/Rentals/hamptons"},
    {name: "Los Angeles Sales", link: "/Sales/los-angeles"},
    {name: "Los Angeles Rentals", link: "/Rentals/los-angeles"},
    {name: "London Sales", link: "/Sales/london"},
    {name: "London Rentals", link: "/Rentals/london"},
    {name: "New Jersey Sales", link: "/Sales/new-jersey"},
    {name: "New Jersey Rentals", link: "/Rentals/new-jersey"},
    {name: "Brooklyn Sales", link: "/Sales/brooklyn"},
    {name: "Brooklyn Rentals", link: "/Rentals/brooklyn"},
    {name: "Greenwich Sales", link: "/Sales/greenwich"},
    {name: "Greenwich Rentals", link: "/Rentals/greenwich"},
    {name: "Connecticut Sales", link: "/Sales/connecticut"},
    {name: "Connecticut Rentals", link: "/Rentals/connecticut"},
    {name: "Palm Beach Sales", link: "/Sales/palm-beach"},
    {name: "Palm Beach Rentals", link: "/Rentals/palm-beach"},
    {name: "Portugal Sales", link: "/Sales/portugal"},
    {name: "Portugal Rentals", link: "/Rentals/portugal"},
    {name: "Long Island City / Queens Sales", link: "/Sales/queen"},
    {name: "Long Island City / Queens Rentals", link: "/Rentals/queen"},
    {name: "Gold Coast Long Island Sales", link: "/Sales/gold-coast-li"},
    {name: "Gold Coast Long Island Rental", link: "/Rentals/gold-coast-li"},
    {name: "Miami Sales", link: "/Sales/florida"},
    {name: "Miami Rental", link: "/Rentals/florida"},
    {name: "San Francisco Sales", link: "/Sales/san-francisco"},
    {name: "San Francisco Rental", link: "/Rentals/san-francisco"},
    {name: "Seoul Sales", link: "/Sales/seoul"},
    {name: "Seoul Rental", link: "/Rentals/seoul"},
    {name: "International Sales", link: "/Sales/international"},
    {name: "International Rental", link: "/Rentals/international"},
    {name: "Commercial Sales", link: "/commercial"},
    {name: "Commerical Rental", link: "/commercial-lease"},
    {name: "Featured Properties", link: "/Properties/Featured"},
    {name: "New Developments", link: "/NewDevelopments"},
    {name: "About", link: "/Company/About"},
    {name: "People", link: "/Company/People"},
    {name: "Career", link: "/Company/Career"},
    {name: "Offices", link: "/Company/Offices"},
    {name: "Press Room", link: "/Company/Press"},
    {name: "Sell your home", link: "/Marketing/Sellers"},
    {name: "Find your dream home", link: "/MyNest/DreamHome"},
    {name: "Furnished Housing", link: "/Properties/Furnished"},
    {name: "Projects and Development", link: "/Marketing/Developers"},
    {name: "Advertising", link: "/Marketing/Advertising"},
    {name: "Connect", link: "/connect"},
    {name: "Social Media", link: "/social-media"},
    {name: "Global Media", link: "/media"},
    {name: "Real Estate Tv", link: "/media/real-estate-tv"},
    {name: "Million Dollar Listing", link: "/million-dollar-listing"},
    {name: "Guides", link: "/Guides"},
    {name: "Neighborhood", link: "/Guides/Neighborhoods"},
    {name: "Mortgages", link: "/Guides/Mortgages"},
    {name: "Market Reports", link: "/Guides/MarketReports"},
]